<template>
    <div>
        <figure class="person-icon">
            <img v-if="attendee.pictureUrl" v-bind:src="attendee.pictureUrl" v-on:click="openPersonCard" onerror='this.onerror = "null"; this.src = "/static/img/anonymous.svg"'>
            <img v-else src="../assets/icons/anonymous.svg" v-on:click="openPersonCard">
            <div class="name">{{attendee.firstName}} {{attendee.lastName}}</div>
        </figure>

    </div>
</template>

<script>
// TODO: reduce space between rows (Manoo's request)
import {LeadBus} from '../router/index';
export default {
    props: {
        attendee: {}
    },

    data() {
        return {
            person: {}
        };
    },

    methods: {
        openPersonCard() {
            this.$emit('openCard', this.attendee);
            LeadBus.$emit('recordLead', {type: 'attendee-profile-card', data: {profileCardOf: this.attendee.id}});
        }
    }
};

</script>

<style lang="scss">

.person-icon {
    width: 80px;
    margin: 0 5px 0 5px;
    flex-basis: 80px;
    max-width: 80px;
    min-height: 120px;
    display: block;
    cursor: pointer;

    img {
        max-width: 80px;
        height: 80px;
        display: block;
        cursor: pointer;
        background-image: url("../assets/icons/anonymous.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .name {
        color: #f1f2f2;
        text-align: center;
        font-weight: 500;
        font-size: 0.6em;
        font-family: "Poppins",sans-serif;
        padding: 5px;
        max-width: 90%;
        text-overflow: ellipsis;
        overflow-x: hidden;
        display: block;
    }
}

</style>



// WEBPACK FOOTER //
// PersonIcon.vue?6b78a9c8